// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__23xe7","tab":"Tabs_tab__1n0g7","tabActive":"Tabs_tabActive__3uJQD"};